// src/hooks/useUserProfile.js
import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { doc, onSnapshot } from "firebase/firestore";
import { auth, db } from "../firebase";

export function useUserProfile() {
    const [state, setState] = useState({
        uid: "",
        role: null,
        groups: [],
        loading: true,
    });

    useEffect(() => {
        const unsubAuth = onAuthStateChanged(auth, (user) => {
            if (!user) {
                setState({ uid: "", role: null, groups: [], loading: false });
                return;
            }

            const ref = doc(db, "users", user.uid);
            const unsubDoc = onSnapshot(
                ref,
                (snap) => {
                    const d = snap.data() || {};
                    setState({
                        uid: user.uid,
                        role: d.role || null,
                        groups: d.groups || [],
                        loading: false,
                    });
                },
                () => setState({ uid: "", role: null, groups: [], loading: false })
            );

            // cleanup cuando cambia de sesión
            return () => unsubDoc();
        });

        return () => unsubAuth();
    }, []);

    return state; // { uid, role, groups, loading }
}
